import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthProtected = (props: any) => {
  const isUserLogout = useSelector((state: any) => state.Login.isUserLogout);

  if (isUserLogout) {
    return <Navigate to="/login" replace />;
  }

  return <>{props.children}</>;
};


export default AuthProtected;